import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import emptyStateImage from 'assets/img/icn-empty-state.svg';

const getCell = (item, key) => {
  try {
    return typeof key === 'function' ? key(item) : _.get(item, key);
  } catch (err) {
    return '-';
  }
};

const GenerictList = ({
  data,
  labelKey,
  label,
  selected,
  selectedKey,
  noRowsLabel,
  isLoading,
  rowsCount,
  pagerData,
  rowHeight,
  height,
  onSelectRow,
  notificationListConfig,
}) => {  

  const handleSelectRow = (item) => e => {
    e.preventDefault();
    if (onSelectRow) {
      onSelectRow(item);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between mx-3 mb-3">
        <span
          style={{ fontSize: '13px', fontWeight: '500', color: '#484848' }}
        >
          {label} {+rowsCount > 0 && ` (${rowsCount})`}
        </span>
        <p
          className="m-0"
          style={{ fontSize: '13px', fontWeight: '500', color: '#484848' }}
        >
          Page {_.get(pagerData, 'current_page') || 0} to{' '}
          {_.get(pagerData, 'total_pages') || 0}
        </p>
      </div>
      <div
        className="generic-listing"
        style={{
          // overflowY: 'scroll',
          display: 'block',
          height: `${height}%`,
        }}
      >
        {isLoading && (
          <div
            className="text-center mt-5"
            style={{
              position: 'absolute',
              zIndex: 5,
              left: 0,
              right: 0,
              margin: '100px auto',
              width: 40,
              height: 40,
              background: '#eaeaea',
              borderRadius: '50%',
              paddingTop: 6,
              fontWeight: 'bolder',
              fontSize: 20,
            }}
          >
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        )}
        {data && data.length < 1 ? (
          <>
            {!isLoading && (
              <div className="d-flex align-items-center justify-content-center h-100">
                <div className="text-center mx-auto py-4">
                  <img
                    src={emptyStateImage}
                    className="img-responsive image-wrapper mb-4 mt-3"
                    alt="Empty State"
                  />
                  <p className="emp-title mb-0">{noRowsLabel}</p>
                </div>
              </div>
            )}
          </>
        ) : (
          data.map(item => {
            const isSelected =
              `${selected}` === `${_.get(item, selectedKey)}`;
            const key = item[selectedKey];
            return (
              <div
                key={key}
                className={`d-flex align-items-center generic-list-item ${
                  isSelected ? 'active' : ''
                }`}
                onClick={handleSelectRow(item, key)}
                style={{
                  cursor: 'pointer',
                  height: `${rowHeight}px`,
                  fontWeight: `${notificationListConfig(item) ? '600' : 'normal'}`,
                  // TODO: add to CMS later
                  backgroundColor: `${notificationListConfig(item)  ? '#f1f3fc' : '#fff'}`,
                  color: `${notificationListConfig(item) ? '#4c6085' : '#000'}`,
                }}
                role="presentation"
              >
                {getCell(item, labelKey)}
              </div>
            );
          })
        )}
      </div>
    </>
  );
}

GenerictList.propTypes = {
  data: PropTypes.instanceOf(Array),
  labelKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  onSelectRow: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.func,
    PropTypes.bool,
  ]),
  selected: PropTypes.string,
  label: PropTypes.string,
  height: PropTypes.number,
  selectedKey: PropTypes.string,
  noRowsLabel: PropTypes.string,
  isLoading: PropTypes.bool,
  rowsCount: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  pagerData: PropTypes.instanceOf(Object),
  rowHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  notificationListConfig: PropTypes.instanceOf(Function),
}

GenerictList.defaultProps = {
  data: [],
  labelKey: 'name',
  onSelectRow: false,
  selected: '',
  selectedKey: 'id',
  label: 'List',
  noRowsLabel: 'There are no items found.',
  isLoading: false,
  rowsCount: false,
  pagerData: {},
  rowHeight: '',
  height: 100,
  notificationListConfig: () => {},
}


export default GenerictList